import { render, staticRenderFns } from "./VariantAddEdit.vue?vue&type=template&id=e5f6c73c"
import script from "./VariantAddEdit.vue?vue&type=script&lang=js"
export * from "./VariantAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports